import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, LinearProgress, Typography } from '@mui/material';
import ILoader from './contracts/ILoader';



interface IProps {
  loaderHook: ILoader;
}
function LoadingDialogComponent({ loaderHook }: IProps) {

  const { loader, RETRY, showDialog, maxRetryCount, RESET } = loaderHook;

  return (<Dialog fullWidth={true} maxWidth={'sm'} open={showDialog} onClose={RESET}>

    <DialogTitle>{loader.title}</DialogTitle>

    <DialogContent>
      {loaderHook.isLoading && <LinearProgress color='secondary' />}
      <Typography variant='body1'>{loader.message}</Typography>
    </DialogContent>

    <DialogActions>
      <Button onClick={RESET}>Close</Button>
      {loaderHook.isFailure && maxRetryCount > 0 && <Button color='warning' onClick={RETRY}>Retry?</Button>}
    </DialogActions>

  </Dialog>)
}
export default LoadingDialogComponent;